import { render } from "./EftProofModal.vue?vue&type=template&id=6eb16fd7"
import script from "./EftProofModal.vue?vue&type=script&lang=js"
export * from "./EftProofModal.vue?vue&type=script&lang=js"

import "./EftProofModal.vue?vue&type=style&index=0&id=6eb16fd7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__